// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","2657":"2453c6da","7497":"016f35d9"}[chunkId] + ".chunk.css";
};